import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Award, Users, Target } from "lucide-react";

const AboutSection = () => {
  return (
    <section className="py-16 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">About SSL Solution</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            We are a leading provider of innovative business solutions, helping organizations
            transform their operations through cutting-edge technology and expert services.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center p-6">
            <Award className="h-12 w-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-2">Excellence</h3>
            <p className="text-muted-foreground">
              Committed to delivering exceptional quality in every solution
            </p>
          </div>
          <div className="text-center p-6">
            <Users className="h-12 w-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-2">Expert Team</h3>
            <p className="text-muted-foreground">
              Skilled professionals dedicated to your success
            </p>
          </div>
          <div className="text-center p-6">
            <Target className="h-12 w-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-2">Innovation</h3>
            <p className="text-muted-foreground">
              Pioneering solutions for tomorrow's challenges
            </p>
          </div>
        </div>
        
        <div className="text-center">
          <Link to="/about">
            <Button variant="outline" size="lg">Learn More About Us</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;